import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind("[data-fancybox]", {
  groupAll: false,
});

$(document).ready(function () {
  function animateCounter($el, target) {
    $({ countNum: 0 }).animate(
      { countNum: target },
      {
        duration: 2000,
        easing: "swing",
        step: function () {
          $el.text(Math.floor(this.countNum).toLocaleString("de-DE"));
        },
        complete: function () {
          $el.text(this.countNum.toLocaleString("de-DE"));
        },
      },
    );
  }
  function startCounters() {
    $(".counter").each(function () {
      var $this = $(this);
      var target = parseInt($this.data("target"));
      if (
        !$this.hasClass("counted") &&
        $(window).scrollTop() + $(window).height() > $this.offset().top
      ) {
        animateCounter($this, target);
        $this.addClass("counted");
      }
    });
  }
  $(window).on("scroll", startCounters);
  startCounters();
});